export default "__VITE_ASSET__Do3sh7Kw__"